import { Box, Container, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Button from '../../Components/Button';
import { fullCenter } from '../../base';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { colorBlueDark } from '../../Resources/Design/theme';

function disableScroll() {
    try {
        document.body.style.overflow = 'hidden';
    } catch { }
}

function enableScroll() {
    try {
        document.body.style.overflow = '';
    } catch { }
}

const InfoIcon = ({ sx = {} }) => {
    return <InfoRoundedIcon sx={{ color: color, height: '29px', width: '29px', mx: 'auto', mt: '24px', display: 'block' }} />;
}

const color = "#4534C2";

export default function Dialog({ dialog, setDialog }) {
    const [password, setPassword] = useState('');
    const [checkPassword, setCheckPassword] = useState('');

    function resetPasswords() {
        if (password) {
            setPassword("");
        }
        if (checkPassword) {
            setCheckPassword("");
        }
    }

    useEffect(() => {
        if (dialog) {
            disableScroll();
        } else {
            enableScroll();
        }
    }, [dialog])

    if (!dialog) {
        return <></>;
    }

    if (dialog?.onAccept) {
        return (
            <Box sx={{ position: 'fixed', zIndex: "999999", width: '100vw', height: '100vh', top: 0, left: 0, bgcolor: 'rgba(0,0,0,0.3)', ...fullCenter, p: '16px' }} onClick={() => {
                if (dialog.forced) return;
                setDialog(false);
            }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px', borderRadius: '12px', bgcolor: 'white', minHeight: '240px', }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <InfoIcon />
                    <Typography variant="list_title" sx={{ maxWidth: '360px', mx: 'auto', my: 'auto', p: '24px', textAlign: 'center', color: colorBlueDark }}>{dialog?.text || ""}</Typography>
                    <Button text={dialog.buttonText || "Potvrdit"} sx={{ width: 'auto', mt: 'auto', mb: '24px', mx: '24px' }} onClick={() => {
                        setDialog(null);
                        if (dialog?.onAccept) {
                            dialog.onAccept();
                        }
                    }} />
                </Box>
            </Box>
        )
    }

    return (
        <Box sx={{ position: 'fixed', zIndex: "999999", width: '100vw', height: '100vh', top: 0, left: 0, bgcolor: 'rgba(0,0,0,0.3)', ...fullCenter, p: '16px' }} onClick={() => {
            if (dialog.forced) return;
            setDialog(false);
        }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px', borderRadius: '12px', bgcolor: 'white', minHeight: '180px', }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <InfoIcon />
                <Typography variant="list_title" sx={{ maxWidth: '360px', mx: 'auto', my: 'auto', px: '24px', pt: '18px', pb: '24px', textAlign: 'center', color: colorBlueDark }}>{dialog}</Typography>
                {Boolean(dialog?.onAccept) && <Button text="Pokračovat" sx={{ width: 'auto', mt: 'auto', mb: '24px', mx: '24px' }} onClick={() => {
                    setDialog(null);
                    if (dialog?.onAccept) {
                        dialog.onAccept();
                    }
                }} />}
            </Box>
        </Box>
    )
}
